import { CIMSPage } from 'shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { HelpMessage } from 'utils/constants'
import { EJType } from '../../../TypesTableContext'

export function useExpand(): ExpandOptions<EJType> {
  return {
    expandable: ({ judgements }) => judgements.length > 0,
    render: ({ id, judgements }) => {
      return {
        additionalInfo: [
          {
            label: 'Associated Judgements',
            help: HelpMessage.EngineeringJudgements.Types.AssociatedJudgements,
            type: 'deepLinks',
            showMore: { key: id },
            links: judgements.map(({ deleted, id, formattedNumber }) => ({
              label: formattedNumber,
              page: CIMSPage.EJLog,
              deep: {
                recordId: id,
                deleted,
              },
            })),
          },
        ],
      }
    },
  }
}
